import { useMemo, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { InstallationTypes } from "../types/genericTables.types";
import { useSamplingPoints } from "../../lib/servicesGenericsTables/useSamplingPoints";

const useFilteredSamplingPoints = (
  installation: InstallationTypes,
  keyReset?: string
) => {
  const form = useFormContext();
  const { samplingPointsList } = useSamplingPoints();

  const filteredSamplingPoints = useMemo(() => {
    if (installation) {
      return samplingPointsList.filter(
        (point) => point.instalacion === installation.codigo
      );
    }
    return [];
  }, [installation, samplingPointsList]);

  useEffect(() => {
    if (!installation && keyReset) {
      form.setValue(keyReset, undefined);
    }
  }, [installation, keyReset, form]);

  return filteredSamplingPoints;
};

export default useFilteredSamplingPoints;
